import { z } from 'zod';
import { MAX_CENARIOS } from './precificacao.js';
import { cuid, isoDate } from './primitives.js';

/**
 * Cenarios do Simulador salvos (Sessao 28): a mesa de trabalho inteira como o formulario a tem (textos como o usuario digita), para reabrir.
 * Nao e a formacao gravada (imutavel): estes se reabrem, duplicam, tem as anotacoes editadas e se excluem.
 */
export const conteudoCenarioSchema = z.object({
  itemId: cuid,
  tabelaId: cuid,
  condicaoId: cuid,
  data: isoDate,
  /** Praticado digitado ("25,00"); vazio = sem. */
  praticado: z.string().max(40).default(''),
  cenarios: z
    .array(z.object({ id: z.number().int().min(1).max(1000), nome: z.string().max(60), campos: z.record(z.string(), z.string().max(40)) }))
    .min(1)
    .max(MAX_CENARIOS),
});
export type ConteudoCenarioDto = z.infer<typeof conteudoCenarioSchema>;

export const salvarCenarioSimuladorSchema = z.object({
  nome: z.string().trim().min(1, 'Informe um nome').max(80, 'O nome tem no máximo 80 caracteres'),
  anotacoes: z.string().trim().max(2000, 'As anotações têm no máximo 2000 caracteres').nullish(),
  conteudo: conteudoCenarioSchema,
});
export type SalvarCenarioSimuladorDto = z.infer<typeof salvarCenarioSimuladorSchema>;

/** PATCH: nome e/ou anotacoes e/ou o conteudo (regravar a mesa). */
export const atualizarCenarioSimuladorSchema = z
  .object({ nome: z.string().trim().min(1).max(80), anotacoes: z.string().trim().max(2000).nullable(), conteudo: conteudoCenarioSchema })
  .partial()
  .refine((v) => Object.keys(v).length > 0, 'Informe ao menos um campo');
export type AtualizarCenarioSimuladorDto = z.infer<typeof atualizarCenarioSimuladorSchema>;

export interface CenarioSimuladorResumo {
  id: string;
  nome: string;
  anotacoes: string | null;
  itemId: string;
  itemCodigo: string;
  itemDescricao: string;
  /** Quantos cenarios a mesa tem. */
  cenarios: number;
  criadoPorNome: string | null;
  criadoEm: string;
  atualizadoEm: string;
}
export interface CenarioSimuladorResponse extends CenarioSimuladorResumo {
  conteudo: ConteudoCenarioDto;
}
export interface CenariosSimuladorListaResponse {
  itens: CenarioSimuladorResumo[];
}
